module.exports = __webpack_public_path__ + "img/popup_first_pay_head.fbd2e88a.png";